// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "admin-260917-32/static/css/" + chunkId + "." + {"1388":"2bfac902","3827":"50997bd3","5979":"459ccf64","6386":"50997bd3","6505":"459ccf64","6703":"4121b45d","8392":"2bfac902","8437":"1cc77895"}[chunkId] + ".chunk.css";
};